'use client';
import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

type TextChild = {
  text: string;
};

type TextBlockContent = {
  children: TextChild[];
};

type TextBlock = {
  heading: string;
  content: TextBlockContent[];
};

type Sections2ColumnTextBlockProps = {
  data: {
    text_block?: TextBlock;
    padding: {
      mobile_top_padding: any;
      mobile_bottom_padding: any;
      desktop_top_padding: any;
      desktop_bottom_padding: any;
    };
    __typename: string;
    heading: string;
    content: TextBlockContent[];
    child?: any;
  };
};
type BlocksRendererProps = React.ComponentProps<typeof BlocksRenderer>;

const ComponentSections2ColumnTextBlock: React.FC<Sections2ColumnTextBlockProps> = ({ data }) => {
  const [top, setTop] = useState('');
  const [bottom, setBottom] = useState('');

  useEffect(() => {
    const updatePadding = () => {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        setTop(data.padding?.mobile_top_padding ?? '');
        setBottom(data.padding?.mobile_bottom_padding ?? '');
      } else {
        setTop(data.padding?.desktop_top_padding ?? '');
        setBottom(data.padding?.desktop_bottom_padding ?? '');
      }
    };

    updatePadding(); // Run on mount

    window.addEventListener('resize', updatePadding); // Listen on resize
    return () => window.removeEventListener('resize', updatePadding); // Clean up
  }, [data]);
  return (
    <section
      className={`grid pb-10 lg:pb-24 pt-0`}
      id={data?.__typename}
      style={{
        paddingTop: `${top}rem`,
        paddingBottom: `${bottom}rem`,
      }}
    >
      <div className="grid grid-cols-12 items-start py-4 pb-0 md:pt-5 gap-7 md:gap-0 border-t  border-[#B6C38066]">
        {/* Heading with animation */}
        <motion.div
          className="col-span-12 md:col-span-6 2xl:col-span-6"
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.h1 className="text-[22px] font-light leading-none">{data?.heading}</motion.h1>
        </motion.div>

        {/* Content block with animation */}
        <motion.div
          className="col-span-12 md:col-span-6 2xl:col-span-6 right-content blocksRenderer"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut', delay: 0.2 }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <div className="indent-16">
            <BlocksRenderer content={data?.content as BlocksRendererProps['content']} />
          </div>
          {/* {data?.content?.map((para, index) => (
            <p key={index} className="leading-[23px] font-light">
              {para.children.map((child, childIdx) => (
                <span className="block indent-10" key={childIdx}>
                  {child.text}
                </span>
              ))}
            </p>
          ))} */}
        </motion.div>
      </div>
    </section>
  );
};

export default ComponentSections2ColumnTextBlock;
